module.exports = __webpack_public_path__ + "static/media/logo.d7bff3a4.png";